// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemIcon_wrapper__w-G7+"};